import { EEthereumNetworkId, Web3KeyWriteProvider } from '@ankr.com/provider';
import BigNumber from 'bignumber.js';
import { AbiItem, fromWei, numberToHex, toWei } from 'web3-utils';

import config, { NetworkConfig } from '../../config';
import KEEPER_REGISTRAR_ABI from './contracts/registrar.json';
import { Web3Provider } from './types';

export function convertFromWei(value: string): BigNumber {
  if (Number.isNaN(Number(value))) {
    throw new Error('Value is not a valid number');
  }

  return new BigNumber(fromWei(value));
}

export function convertToWei(value: BigNumber | string | number): string {
  const BNValue = value instanceof BigNumber ? value : new BigNumber(value);

  if (BNValue.isNaN()) {
    throw new Error('Value is not a valid number');
  }

  return toWei(BNValue.toString());
}

export function convertToHex(value: BigNumber): string {
  const valueAsWei = toWei(value.toString());

  return numberToHex(valueAsWei);
}

const REGISTER_FUNCTION_NAME = 'register';
export function getRegisterAbiItem(): AbiItem {
  const abiItems = KEEPER_REGISTRAR_ABI as AbiItem[];

  const abiItem = abiItems.find(
    ({ type, name }) => type === 'function' && name === REGISTER_FUNCTION_NAME,
  );
  if (!abiItem) {
    throw new Error(
      `${REGISTER_FUNCTION_NAME} function is not found in Registrar Contract ABI`,
    );
  }

  return abiItem;
}

export function isValidAbi(value: unknown): value is AbiItem[] {
  if (!Array.isArray(value) || !value.length) {
    return false;
  }

  return value.every(item => !!item.type);
}

export function isWeb3KeyWriteProvider(
  provider: Web3Provider,
): provider is Web3KeyWriteProvider {
  return provider instanceof Web3KeyWriteProvider;
}

export function getNetworkConfig(chainId: EEthereumNetworkId): NetworkConfig {
  const networkConfig = config[chainId];
  if (!networkConfig) {
    throw new Error(
      `NetworkConfig for chain ${String(chainId)} is not defined`,
    );
  }

  return networkConfig;
}
